import http from 'utils/http';

export const getEzCaterIntegration = (organizationId) => http
  .get(`v1/organizations/${organizationId}/ezcater-integration/`)
  .then((res) => res.data?.data ?? res.data);

export const requestEzCaterActivation = (organizationId) => http
  .post(`v1/organizations/${organizationId}/ezcater-integration/request-activation/`)
  .then((res) => res.data?.data ?? res.data);

export const saveEzCaterCredentials = (organizationId, payload) => http
  .patch(`v1/organizations/${organizationId}/ezcater-integration/`, payload)
  .then((res) => res.data?.data ?? res.data);

export const testEzCaterConnection = (organizationId) => http
  .post(`v1/organizations/${organizationId}/ezcater-integration/test-connection/`)
  .then((res) => res.data?.data ?? res.data);

export const getEzCaterCaterers = (organizationId) => http
  .get(`v1/organizations/${organizationId}/ezcater-integration/caterers/`)
  .then((res) => res.data?.data ?? res.data);

export const getEzCaterMappableRestaurants = (organizationId) => http
  .get(`v1/organizations/${organizationId}/ezcater-integration/mappable-restaurants/`)
  .then((res) => res.data?.data ?? res.data);

export const saveEzCaterCatererMapping = (organizationId, payload) => http
  .put(`v1/organizations/${organizationId}/ezcater-integration/caterer-mappings/`, payload)
  .then((res) => res.data?.data ?? res.data);

export const removeEzCaterCatererMapping = (organizationId, catererUuid) => http
  .delete(`v1/organizations/${organizationId}/ezcater-integration/caterer-mappings/${catererUuid}/`)
  .then((res) => res.data?.data ?? res.data);
